import { createLogger, INFO, TRACE, DEBUG, WARN, stdSerializers } from 'browser-bunyan';
import { ConsoleFormattedStream } from '@browser-bunyan/console-formatted-stream';

export enum LogLevel {
  TRACE = 'TRACE',
  INFO = 'INFO',
  DEBUG = 'DEBUG',
  WARN = 'WARN',
  ERROR = 'ERROR',
}

/**
 * https://github.com/pimterry/loglevel
 * https://github.com/philmander/browser-bunyan
 */
class LogService {
  private log: any;

  public init(logLevel: LogLevel) {
    this.log = createLogger({
      name: 'ETV',
      streams: [
        {
          level: logLevel, // or use the string 'info'
          stream: new ConsoleFormattedStream(),
        },
      ],
      serializers: stdSerializers,
      src: true,
    });

    this.log.info('INIT LOGSERVICE');
    // catch all TODO: add to index.html? to cathc errors before logger initilized
    window.onerror = (errorMsg, url, lineNumber) => {
      this.log.error(errorMsg);
      return false;
    };
  }

  public trace(msg: string, object?: any) {
    this.log.trace({ obj: object }, msg);
  }

  public debug(msg: string, object?: any) {
    this.log.debug({ obj: object }, msg);
  }

  public info(msg: string, object?: any) {
    this.log.info({ obj: object }, msg);
  }

  public warn(msg: string, object?: any) {
    this.log.warn({ obj: object }, msg);
  }

  public error(msg: string, object?: any) {
    this.log.error({ obj: object }, msg);
  }
}

export const logService = new LogService();
